// Build marker: bumped 2026-05-04 to force Railway frontend rebuild after
// the gitleaks-allowlist fix unblocked CI on cdc143d's redesign + 396f6cb's
// admin-meta extensions. Railway's per-service path-watching skipped the
// .gitleaks.toml-only commit that fixed CI, so the frontend image stayed
// pinned to the pre-redesign bundle until this no-op touch.
import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import { useAuthStore } from './stores/auth'

import './design/tokens.css'
import './design/base.css'

const app = createApp(App)
const pinia = createPinia()
app.use(pinia)

// Bootstrap auth from localStorage before mounting so the router guard sees
// a hydrated user on first navigation.
const auth = useAuthStore()
auth.bootstrap().finally(() => {
  app.use(router)
  app.mount('#app')
})
